// Stub for strategy engine service - replace with actual implementation
export class StrategyEngine {
  getStrategies = async () => [];
  getActiveStrategy = () => null;
  setActiveStrategy = async (_strategyId: string) => true;
  executeStrategy = async (_strategyId: string, _params: any) => null;
}

export const strategyEngine = new StrategyEngine();
